// What happens to test answers still waiting on this device when someone signs out (F21).
//
// - The automatic sign-outs (the daily one on the website, a session that ended and couldn't
//   be renewed) keep the student's own waiting answers on a personal phone: they send once the
//   same student is back. answerOutbox.js never sends them under anyone else, and opening a
//   test clears other students' kept answers.
// - On a shared computer (utils/sharedComputer.js) every sign-out still clears them.
// - Sign out asks first when answers are waiting (SignOutConfirm.js); going ahead clears them.
import { clearWaitingAnswers, signedInUserId } from './answerOutbox';

const PREFIX = 'anna:waitingAnswers:';

const storage = () => {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

/** { count, tests } of the answers waiting on this device for `owner` (the signed-in student). */
export const waitingSummary = (owner = signedInUserId()) => {
  const store = storage();
  const summary = { count: 0, tests: [] };
  if (!store || !owner) return summary;
  try {
    for (let i = 0; i < store.length; i += 1) {
      const key = store.key(i);
      if (!key || !key.startsWith(`${PREFIX}${owner}:`)) continue;
      const record = JSON.parse(store.getItem(key) || 'null');
      const entries = Array.isArray(record?.entries) ? record.entries.length : 0;
      if (entries > 0) {
        summary.count += entries;
        summary.tests.push(record.test || key.slice(`${PREFIX}${owner}:`.length));
      }
    }
  } catch {
    // Unreadable storage: nothing we can count
  }
  return summary;
};

/** How many answers are waiting for this student on this device. */
export const waitingCount = (owner) => waitingSummary(owner).count;

/**
 * Called by every sign-out path before the tokens go. `shared`: the shared-computer choice,
 * read while the student was still signed in. `manual`: the student tapped Sign out (they
 * were asked first, so their answers go too).
 */
export const clearWaitingOnSignOut = ({ shared = false, manual = false } = {}) => {
  if (shared || manual) clearWaitingAnswers();
};
